import { render, staticRenderFns } from "./EditOccupant.vue?vue&type=template&id=0971a4ec"
import script from "./EditOccupant.vue?vue&type=script&lang=js"
export * from "./EditOccupant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports